module.exports = __webpack_public_path__ + "static/join_international_obj04@2x-4f73a5001426db535388c084f63f2f10.png";